import { CONFIG_NO_ERROR_TOAST, DURATION_1_HR } from '@src/constants';
import { adminRefreshTokenService } from '@src/services/admin-auth-service';
import ClientApi from '@src/types/client';
import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

export const useAdminRefreshToken = (
  options?: UseQueryOptions<
    ClientApi.AdminAuth.AdminRefreshToken.Response,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    AxiosError<any>
  >
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useQuery<ClientApi.AdminAuth.AdminRefreshToken.Response, AxiosError<any>>({
    queryKey: ['adminRefreshToken'],
    queryFn: () => adminRefreshTokenService(CONFIG_NO_ERROR_TOAST),
    staleTime: DURATION_1_HR,
    ...options
  });
};
